<template>
  <div>
    <tabbar v-model="active">
      <!--            <tabbar-item icon="home-o" @click="home">首页</tabbar-item>-->
      <tabbar-item class="iconfont icon-home-copy" @click="home">
        <span style="font-size: 10px">首页</span></tabbar-item
      >
      <!-- 分割线 -->
      <!-- 
      <tabbar-item
        v-if="isWechat && openTypeAuth"
        class="iconfont icon-icon-gonghui"
      >
        <wx-open-launch-weapp
          id="pull-btn"
          username="gh_5e7385971f98"
          path="pages/index/index"
        >
          <script type="text/wxtag-template">
            <style>.pull_btn { font-size: 10px }</style>
            <span class="pull_btn">职工e家</span>
          </script>
        </wx-open-launch-weapp>
      </tabbar-item> -->

      <!-- <tabbar-item
        v-else-if="!isWechat || !openTypeAuth"
        class="iconfont icon-icon-gonghui"
        @click="staffHeadlines"
      >
        <span style="font-size: 10px">职工e家</span>
      </tabbar-item> -->

      <!-- <tabbar-item class="iconfont icon-gongzuoquan" >
                <span style="font-size: 10px" >工作圈</span></tabbar-item>
            <tabbar-item class="iconfont icon-shangcheng" >
                <span style="font-size: 10px" >积分商城</span></tabbar-item> -->
      <tabbar-item icon="manager" @click="personalCenter">
        <span style="font-size: 10px">个人中心</span></tabbar-item
      >
    </tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem, Toast } from "vant";

export default {
  name: "foot",
  components: {
    Tabbar,
    TabbarItem,
  },
  data() {
    return {
      active: 0,
      isWechat: false,
      openTypeAuth: false,
    };
  },
  computed: {
    routePath() {
      return this.$route.path;
    },
  },
  watch: {
    routePath: {
      handler(newV) {
        if (newV == "/home") this.active = 0;
        if (newV == "/personalCenter") this.active = 1;
      },
      immediate: true,
    },
  },
  created() {
    console.warn(this.$wxUtils);
    this.isWechat = this.$wxUtils.isWechat();
    // Toast.success(this.isWechat.toString());
    this.initPullMini();
  },
  methods: {
    //首页
    home() {
      if (this.$route.path == "/home") return;
      this.$router.push({ path: "/home" });
    },
    //个人中心
    personalCenter() {
      if (this.$route.path == "/personalCenter") return;
      this.$router.push({ path: "/personalCenter" });
    },
    staffHeadlines() {
      this.$emit("showPopup");
    },
    initPullMini() {
      this.$wxUtils.initConfig(
        () => {
          let dom = document.getElementById("pull-btn");
          if (dom) {
            // this.domRender = true;
            dom.addEventListener("launch", (e) => {
              console.warn("launch: ", e);
              Toast.success("启动成功");
            });
            dom.addEventListener("error", (e) => {
              console.error("error: ", e);
              Toast.fail("启动失败");
            });
          }
          this.openTypeAuth = true;
          console.warn("openTypeAuth: ", this.openTypeAuth);
        },
        () => {
          // Toast.fail("config fail");
        }
      );
    },
  },
};
</script>

<style scoped>
</style>